<!-- eslint-disable -->
<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { closeModal, openModal } from '@kolirt/vue-modal';
import { BetSlip } from '@/stores/BetSlip';
import { useSharedBetslipsStore } from '@/stores/shared_betslips';
import SharedBetslipError from '@/components/modals/SharedBetslipError.vue';

const { t } = useI18n();
const betslipStore = BetSlip();
const sharedBetslipStore = useSharedBetslipsStore();

const shared_betslip_code = ref(null);
const button_disabled = ref(true);

function onClose() {
	closeModal().catch(() => {});
}

function fetchSharedBetslip() {
	if (shared_betslip_code.value == null || shared_betslip_code.value === '') return;

	sharedBetslipStore.fetchSharedBetslip(shared_betslip_code.value).then((response) => {
		betslipStore.resetBetslip();

		const bets = JSON.parse(response.bets);
		const shared_id = shared_betslip_code.value;

		const id = response.id;
		let must_delete = false;

		for (const index in bets) {
			const bet = bets[index];

			betslipStore
				.toggleToBetslip({ odd_uuid: bet.bet_uuid, fixture_id: bet.fixture_id }, shared_id, id)
				.catch((error) => {
					if (!must_delete) {
						// sharedBetslipStore.deleteSharedBetslip(shared_id, false);
						must_delete = true;
					}
				});
		}

		shared_betslip_code.value = null;
		closeModal().catch(() => {});
	}).catch((error) => {
		// rate limited: just ignore
		if (error.response?.status === 429) return;
		openModal(SharedBetslipError, { errors: error.response, need_redirect: false }).catch(() => {});
	});
}

watch(() => shared_betslip_code.value, (newValue) => {
		if (newValue != '' && newValue != null) button_disabled.value = false;
		else button_disabled.value = true;
	}
);
</script>

<template>
	<section class="shared-betslip-input-modal">
		<div class="shared-betslip-card">
			<div class="shared-betslip-header">
				<h5 class="shared-betslip-title">
					{{ $t('share_bet.your_booking_code') }}
				</h5>
				<button type="button" class="shared-betslip-close" @click="onClose">
					<i class="fa fa-times" aria-hidden="true" />
				</button>
			</div>

			<p class="shared-betslip-subtitle">
				{{ $t('general.type_shared_bet_code') }}
			</p>

			<div class="grid">
				<div class="text-field">
					<input
						type="text"
						class="form-input"
						v-model="shared_betslip_code"
						:placeholder="$t('general.type_shared_bet_code')"
					>
					<a @click="shared_betslip_code = null">
						<i class="fa fa-times-circle clear-button" aria-hidden="true" />
					</a>
				</div>
				<button
					class="share-btn"
					:class="{ 'btn-disabled': button_disabled }"
					type="button"
					@click="fetchSharedBetslip"
				>
					<i class="fa fa-plus" aria-hidden="true" style="margin-right: 2px;" />&nbsp;{{ $t('general.add_bets') }}
				</button>
			</div>
		</div>
	</section>
</template>

<style scoped>
.shared-betslip-input-modal {
	padding: 20px;
}

.shared-betslip-card {
	background: var(--dark-gray);
	border-radius: 6px;
	border: 1px solid var(--tab-gray);
	padding: 20px 20px 16px 20px;
	min-width: 280px;
	max-width: 420px;
}

.shared-betslip-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	margin-bottom: 8px;
	color: var(--primary);
}

.shared-betslip-title {
	color: var(--primary);
	font-size: 15px;
	font-weight: 600;
	margin: 0;
}

.shared-betslip-close {
	background: transparent;
	border: none;
	color: var(--light-gray);
	cursor: pointer;
}

.shared-betslip-subtitle {
	color: var(--light-gray);
	font-size: 12px;
	margin: 0 0 10px 0;
}

.grid {
	display: grid;
	grid-template-columns: minmax(0, 1fr) auto;
	gap: 8px;
	align-items: center;
}

.text-field {
	position: relative;
}

.form-input {
	width: 100%;
	padding: 6px 28px 6px 8px;
	border-radius: 4px;
	border: 1px solid var(--tab-gray);
	background: var(--dark);
	color: var(--white);
	font-size: 13px;
}

.clear-button {
	position: absolute;
	top: 50%;
	right: 8px;
	transform: translate(-50%, -50%);
	cursor: pointer;
	width: 14px;
	color: var(--off-light-gray);
}

html[dir='rtl'] .clear-button {
	left: 16px;
	right: unset;
}

.share-btn {
	background: var(--secondary);
	color: var(--dark-gray);
	border: 1px solid transparent;
	height: 32px;
	border-radius: 4px;
	cursor: pointer;
	font-size: 12px;
	font-weight: 500;
	text-decoration: none;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 0 10px;
	text-wrap: nowrap;
}

.share-btn:hover {
	border: 1px solid var(--light-gray);
	background: var(--dark);
	color: var(--white);
}

.btn-disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

@media screen and (max-width: 480px) {
	.shared-betslip-card {
		max-width: 100%;
		padding: 16px 14px 12px 14px;
	}
}
</style>

